import { createClient } from "@supabase/supabase-js"

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabasePublishableDefaultKey = import.meta.env
  .VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY

export const supabase = createClient(supabaseUrl, supabasePublishableDefaultKey)

export type ContactSubmission = {
  id: number
  name: string
  email: string
  phone: string | null
  message: string
  created_at: string
}
